'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _BaseList = require('../common/BaseList');

var _BaseList2 = _interopRequireDefault(_BaseList);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _CaseUpdateModal = require('../page-case/main-details/CaseUpdates/CaseUpdateModal');

var _CaseUpdateModal2 = _interopRequireDefault(_CaseUpdateModal);

var _constants = require('../../constants');

var _utils = require('../../utils');

var _util = require('../../utils/util');

var _EmptyListHelpText = require('../page-tasks/EmptyListHelpText');

var _EmptyListHelpText2 = _interopRequireDefault(_EmptyListHelpText);

var _CaseTrackingHeader = require('./CaseTrackingHeader');

var _CaseTrackingHeader2 = _interopRequireDefault(_CaseTrackingHeader);

var _caseTrackingListRenderUtils = require('./caseTrackingListRenderUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var renderDate = _utils.TableRenderingUtils.renderDate,
    renderLawFirmAndAttorney = _utils.TableRenderingUtils.renderLawFirmAndAttorney,
    renderMoney = _utils.TableRenderingUtils.renderMoney,
    renderRegistrySharingEligibilityStatuses = _utils.TableRenderingUtils.renderRegistrySharingEligibilityStatuses,
    renderUnformatted = _utils.TableRenderingUtils.renderUnformatted,
    CASE_TRACKING_PAGE_SIZE = _constants.AppConstants.CASE_TRACKING_PAGE_SIZE,
    USER_FLOW = _constants.AppConstants.USER_FLOW,
    MightyVersionVisibility = {
  FREE_ONLY: 'free',
  PAID_ONLY: 'paid'
};
var CaseTrackingList = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'SessionStore', 'UiStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CaseTrackingList, _Component);

  function CaseTrackingList(props) {
    _classCallCheck(this, CaseTrackingList);

    var _this = _possibleConstructorReturn(this, (CaseTrackingList.__proto__ || Object.getPrototypeOf(CaseTrackingList)).call(this, props));

    _initDefineProp(_this, 'currentPageNumber', _descriptor, _this);

    _initDefineProp(_this, 'data', _descriptor2, _this);

    _initDefineProp(_this, 'overlayContainer', _descriptor3, _this);

    _initDefineProp(_this, 'selectedRows', _descriptor4, _this);

    _initDefineProp(_this, 'showUpdateModal', _descriptor5, _this);

    _this.caseIdKey = null;
    _this.searchString = null;
    var isMightyFreeUser = _this.props.SessionStore.isMightyFreeUser;

    _this.caseIdKey = isMightyFreeUser ? 'id' : 'case_id';
    return _this;
  }

  _createClass(CaseTrackingList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var searchString = this.props.searchString;

      // Record what we are about to load before loading it. Without this the guard below compares
      // against null forever, so every parent re-render re-fetches the page we already have.

      this.searchString = searchString;

      // The page pushes its filters onto the URL on mount; we fetch when they arrive as new props.
      if (searchString === 'INITIAL') {
        return;
      }

      this.fetchTableData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.searchString !== nextProps.searchString) {
        this.searchString = nextProps.searchString;
        this.fetchTableData();
      }
    }
  }, {
    key: 'handleQuickUpdateButtonClick',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(caseId) {
        var _props, CaseStore, caseTrackingPage, SessionStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, CaseStore = _props.CaseStore, caseTrackingPage = _props.UiStore.caseTrackingPage, SessionStore = _props.SessionStore;

                caseTrackingPage.loading = true;
                SessionStore.trackEvent('TRACKING_UPDATE_FROM_LIST_PAGE', { case_id: caseId });
                _context.next = 5;
                return CaseStore.retrieve(caseId, { caseOnly: true });

              case 5:
                this.updateCase = _context.sent;

                this.showUpdateModal.setTrue();
                caseTrackingPage.loading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleQuickUpdateButtonClick(_x) {
        return _ref.apply(this, arguments);
      }

      return handleQuickUpdateButtonClick;
    }()
  }, {
    key: 'handlePagination',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(page) {
        var query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = _urijs2.default.parse(page).query;


                this.currentPageNumber = (0, _util.setPagination)(query);
                _context2.next = 4;
                return this.fetchTableData(true);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePagination(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: 'filterOutSelectedRowsNotInData',
    value: function filterOutSelectedRowsNotInData(idKey) {
      var _this2 = this;

      return this.selectedRows.filter(function (selectedRow) {
        return _this2.data.find(function (fetchedDataRow) {
          return fetchedDataRow[idKey] === selectedRow[idKey];
        });
      });
    }
  }, {
    key: 'toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut',
    value: function toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut() {
      var caseTrackingPage = this.props.UiStore.caseTrackingPage;

      if ('has_tracking_contact_email' in caseTrackingPage.query) {
        // this branch has no coverage due to router never triggering a refresh event from tests
        // istanbul ignore next
        _utils.toast.success('Cases without tracking contact emails have been filtered out. Now you can request case status updates.');
      }
    }
  }, {
    key: 'fetchTableData',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var paginating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _props2, caseTrackingPage, funder, params, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, caseTrackingPage = _props2.UiStore.caseTrackingPage, funder = _props2.FunderStore.funder;

                caseTrackingPage.loading = true;

                if (!paginating) {
                  this.currentPageNumber = '1';
                }

                _context3.prev = 3;
                params = _extends({}, caseTrackingPage.query, { page: this.currentPageNumber, page_size: CASE_TRACKING_PAGE_SIZE });
                _context3.next = 7;
                return this.clientRows.list({ params: params });

              case 7:
                data = _context3.sent;

                this.data = data.results;

                caseTrackingPage.total = data.count;
                caseTrackingPage.tableData = (0, _caseTrackingListRenderUtils.serializeColumns)(funder.mighty_service_tier, this.data);
                caseTrackingPage.nextPageURL = data.next;
                caseTrackingPage.previousPageURL = data.previous;
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](3);

                _utils.toast.error('There was an error fetching the case tracking list.');
                throw _context3.t0;

              case 19:
                _context3.prev = 19;

                caseTrackingPage.loading = false;
                this.selectedRows = this.filterOutSelectedRowsNotInData(this.caseIdKey);
                return _context3.finish(19);

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 15, 19, 23]]);
      }));

      function fetchTableData() {
        return _ref3.apply(this, arguments);
      }

      return fetchTableData;
    }()
  }, {
    key: 'updateCaseTrackingStatus',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(caseId, data) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.CaseStore.updateCaseTrackingStatus(caseId, data);

              case 2:
                _context4.next = 4;
                return this.fetchTableData();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateCaseTrackingStatus(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return updateCaseTrackingStatus;
    }()
  }, {
    key: 'rowLocation',
    value: function rowLocation(state, rowInfo, column) {
      var case_id = (0, _get3.default)(rowInfo, 'original.case_id');
      return !!case_id && { pathname: '/case/' + case_id + '/details/feed', state: USER_FLOW.FROM_CASE_TRACKING_PAGE };
    }
  }, {
    key: 'onSelectRows',
    value: function onSelectRows(selectedCases) {
      var _this3 = this;

      var selectedDataRows = selectedCases && selectedCases.map(function (selectedCase) {
        return _this3.data.find(function (row) {
          return row[_this3.caseIdKey] === selectedCase;
        });
      });
      this.selectedRows = selectedDataRows.filter(function (s) {
        return s;
      });
    }
  }, {
    key: 'setListRef',
    value: function setListRef(ref) {
      this.overlayContainer = ref;
    }
  }, {
    key: 'onFilterOutCasesWithNoTrackingContacts',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6) {
        var isReset = _ref6.isReset;
        var query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                query = { has_tracking_contact_email: isReset ? null : true };
                _context5.next = 3;
                return this.props.onFilterChange(query);

              case 3:
                this.toastSuccessIfCasesWithNoTrackingContactsHaveBeenFilteredOut();

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onFilterOutCasesWithNoTrackingContacts(_x6) {
        return _ref5.apply(this, arguments);
      }

      return onFilterOutCasesWithNoTrackingContacts;
    }()
  }, {
    key: 'callScheduleBulkCaseTrackingTasksForSelectedCases',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this4 = this;

        var selectedCaseIds, numberOfUpdatesRequested;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                selectedCaseIds = this.selectedRows.map(function (row) {
                  return { case: row[_this4.caseIdKey] };
                }), numberOfUpdatesRequested = selectedCaseIds.length;
                _context6.next = 3;
                return this.props.Clients.caseTrackingUpdateTasks.create(selectedCaseIds);

              case 3:
                _utils.toast.success('Success! ' + numberOfUpdatesRequested + ' updates requested');

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function callScheduleBulkCaseTrackingTasksForSelectedCases() {
        return _ref7.apply(this, arguments);
      }

      return callScheduleBulkCaseTrackingTasksForSelectedCases;
    }()
  }, {
    key: 'onSendRequestUpdates',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                this.onFilterOutCasesWithNoTrackingContacts({ isReset: true });
                _context7.next = 4;
                return this.callScheduleBulkCaseTrackingTasksForSelectedCases();

              case 4:
                _context7.next = 9;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7['catch'](0);

                _utils.toast.error('There was an error scheduling update requests');

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 6]]);
      }));

      function onSendRequestUpdates() {
        return _ref8.apply(this, arguments);
      }

      return onSendRequestUpdates;
    }()
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;

      return _react2.default.createElement(_CaseTrackingHeader2.default, {
        fetchTableData: this.fetchTableData,
        isMightyFreeUser: isMightyFreeUser,
        onFilterOutCasesWithNoTrackingContacts: this.onFilterOutCasesWithNoTrackingContacts,
        onSendRequestUpdates: this.onSendRequestUpdates,
        selectedRows: this.selectedRows
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var UiStore = this.props.UiStore;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_BaseList2.default, {
          columns: this.tableColumns,
          currentPageNumber: this.currentPageNumber,
          emptyText: this.emptyText,
          entityType: 'cases',
          handlePagination: this.handlePagination,
          handleSort: this.fetchTableData,
          onSelectRows: this.onSelectRows,
          pageSize: CASE_TRACKING_PAGE_SIZE,
          pageStore: UiStore.caseTrackingPage,
          paginated: true,
          ref: this.setListRef,
          renderHeader: this.renderHeader,
          rowLocation: this.rowLocation,
          selectable: true,
          selectedRows: (0, _mobx.toJS)(this.selectedRows.map(function (selectedRow) {
            return selectedRow[_this5.caseIdKey];
          }))
        }),
        this.showUpdateModal.isTrue && _react2.default.createElement(_CaseUpdateModal2.default, {
          _case: this.updateCase,
          onClose: this.showUpdateModal.setFalse,
          onCreate: this.updateCaseTrackingStatus
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'clientRows',
    get: function get() {
      var _props3 = this.props,
          SessionStore = _props3.SessionStore,
          Clients = _props3.Clients;


      if (SessionStore.isMightyFreeUser) {
        return Clients.casePortfolio;
      }

      return Clients.openCaseSummary;
    }
  }, {
    key: 'tableColumns',
    get: function get() {
      var _props4 = this.props,
          isMightyFreeUser = _props4.SessionStore.isMightyFreeUser,
          _props4$FunderStore = _props4.FunderStore,
          isMedicalProvider = _props4$FunderStore.isMedicalProvider,
          isRegistryEnabled = _props4$FunderStore.isRegistryEnabled,
          plaintiffPrefix = isMightyFreeUser ? 'plaintiff__' : 'plaintiff_',
          columns = [{
        accessor: plaintiffPrefix + 'last_name',
        Cell: renderUnformatted,
        className: 'fs-mask',
        Header: 'Last Name',
        maxWidth: 130
      }, {
        accessor: plaintiffPrefix + 'first_name',
        Cell: renderUnformatted,
        className: 'fs-mask',
        Header: 'First Name',
        maxWidth: 130
      }, {
        accessor: 'tracking_follow_up_date',
        Cell: renderDate,
        Header: 'Follow up',
        maxWidth: 125,
        minWidth: 115
      }, {
        accessor: 'tracking_contact',
        Cell: _caseTrackingListRenderUtils.renderTrackingContact,
        clickable: false,
        Header: 'Tracking Contact',
        maxWidth: 180,
        minWidth: 120,
        overlayContainer: this.overlayContainer,
        visibility: MightyVersionVisibility.PAID_ONLY
      }, {
        accessor: isMightyFreeUser ? 'lawfirm__name' : 'lawfirm',
        Cell: renderLawFirmAndAttorney,
        Header: 'Law Firm & Attorney',
        maxWidth: 300
      }, {
        accessor: isMedicalProvider ? 'total_billing_amount_of_liens' : 'principal_amount',
        Cell: renderMoney,
        Header: isMedicalProvider ? 'Billing Amount' : 'Principal',
        maxWidth: 160,
        minWidth: 120,
        visibility: MightyVersionVisibility.PAID_ONLY
      }, {
        accessor: 'last_tracking_update',
        Cell: _caseTrackingListRenderUtils.renderLastCaseUpdate.bind(this, this.handleQuickUpdateButtonClick, !isMightyFreeUser),
        clickable: isMightyFreeUser,
        Header: 'Last Case Update',
        id: isMightyFreeUser ? 'tracking_summary__last_update_recorded_at' : 'last_tracking_update_recorded_at',
        minWidth: 100,
        sortable: true
      }],
          registryColumns = [{
        accessor: 'registry_sharing_eligibility',
        Cell: renderRegistrySharingEligibilityStatuses,
        Header: 'Law Firm Portal Eligibility',
        minWidth: 100,
        sortable: false
      }];


      if (isMightyFreeUser) {
        return columns.filter(function (column) {
          return column.visibility !== MightyVersionVisibility.PAID_ONLY;
        });
      }

      if (isRegistryEnabled) {
        return [].concat(columns, registryColumns);
      }

      return columns;
    }
  }, {
    key: 'emptyText',
    get: function get() {
      var _props5 = this.props,
          _props5$UiStore$caseT = _props5.UiStore.caseTrackingPage,
          filters = _props5$UiStore$caseT.filters,
          total = _props5$UiStore$caseT.total,
          isMightyFreeUser = _props5.SessionStore.isMightyFreeUser,
          actionText = _react2.default.createElement(
        'span',
        null,
        'To add new cases, navigate to our New Case Page ',
        _react2.default.createElement(
          _reactRouter.Link,
          { href: '/new-case' },
          _react2.default.createElement(
            'b',
            null,
            'here.'
          )
        )
      );

      if (isMightyFreeUser && (0, _isEmpty3.default)(filters) && total === 0) {
        return _react2.default.createElement(_EmptyListHelpText2.default, {
          actionText: actionText,
          subtitle: 'You have not added any cases yet!',
          title: 'This is your new Case Portfolio Page'
        });
      }

      return '';
    }
  }]);

  return CaseTrackingList;
}(_react.Component), _class3.propTypes = {
  CaseStore: _propTypes2.default.object.isRequired,
  Clients: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  onFilterChange: _propTypes2.default.func.isRequired,
  searchString: _propTypes2.default.string.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'currentPageNumber', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '1';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'data', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'overlayContainer', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'selectedRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'showUpdateModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handlePagination', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handlePagination'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseTrackingList;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(renderDate, 'renderDate', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderLawFirmAndAttorney, 'renderLawFirmAndAttorney', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderMoney, 'renderMoney', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderRegistrySharingEligibilityStatuses, 'renderRegistrySharingEligibilityStatuses', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(renderUnformatted, 'renderUnformatted', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(CASE_TRACKING_PAGE_SIZE, 'CASE_TRACKING_PAGE_SIZE', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(MightyVersionVisibility, 'MightyVersionVisibility', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(CaseTrackingList, 'CaseTrackingList', '/app/src/components/page-case-tracking/CaseTrackingList.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-tracking/CaseTrackingList.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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